import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const WishlistSuggestionsKeywords = dynamic(
  () => import('components/Wishlist/WishlistSuggestionsKeywords'),
  { ssr: false }
);

const MAX_WISHLIST_KEYWORDS = 3;

const HeroMessage = ({
  gaEventCategory,
  wishlistKeywords,
  onEditWishlistButtonClick,
}) => (
  <Box className="mb-4 border-t-0">
    <div
      className={twJoin(
        'grid w-full grid-cols-[1fr_2fr] px-6 pt-4 md:grid-cols-[174px_2fr_1fr] md:px-8 md:pt-6',
        wishlistKeywords.length > 0
          ? 'md:grid-rows-4'
          : 'pb-4 md:grid-rows-3 md:pb-0'
      )}
    >
      <Image
        alt="Página não encontrada"
        className="row-span-3 md:hidden md:w-[174px]"
        height={174}
        loading={null}
        sizes="(max-width: 768px) 98px, 1px"
        src={`${APP.LOCAL_IMAGE_PATH}/features/search-results/result-not-found-mobile.svg`}
        srcSet={`
          ${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w,
          ${APP.LOCAL_IMAGE_PATH}/features/search-results/result-not-found-mobile.svg 98w
        `}
        width={98}
        aria-hidden
      />
      <Image
        alt="Página não encontrada"
        className="row-span-3 hidden md:block"
        height={174}
        loading={null}
        sizes="(max-width: 768px) 1px, 174px"
        src={`${APP.LOCAL_IMAGE_PATH}/features/search-results/result-not-found.svg`}
        srcSet={`
          ${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w,
          ${APP.LOCAL_IMAGE_PATH}/features/search-results/result-not-found.svg 174w
        `}
        width={174}
        aria-hidden
      />
      <div className="ml-3 md:col-span-1 md:ml-6">
        <Heading as="h1" className="mb-2" size="size5">
          {placeholder('titles.noOfferResultsFound')}
        </Heading>
      </div>
      <div className="ml-3 md:col-span-2 md:ml-6">
        <Text>{placeholder('descriptions.noOfferResultsFound')}</Text>
      </div>
      <div className="flex justify-end md:col-start-3 md:row-end-2">
        <Link
          className="mb-4 mt-3 self-end lg:mt-0"
          onClick={onEditWishlistButtonClick}
        >
          {placeholder('actions.editWishlistShort')}
        </Link>
      </div>
      {wishlistKeywords.length > 0 && (
        <div className="col-span-2 mt-3 w-full flex-nowrap overflow-x-auto md:col-start-2">
          <WishlistSuggestionsKeywords
            gaEventCategory={gaEventCategory}
            keywordsDisplay={wishlistKeywords}
            maxKeywords={MAX_WISHLIST_KEYWORDS}
            keywordButtonTypeCanChange
          />
        </div>
      )}
    </div>
  </Box>
);

HeroMessage.propTypes = {
  wishlistKeywords: PropTypes.arrayOf(PropTypes.string).isRequired,
  onEditWishlistButtonClick: PropTypes.func.isRequired,
};

export default HeroMessage;
